import React from 'react';
import { RiSearchLine } from 'react-icons/ri';

interface IProps {
  placeholder?: string;
  query?: string;
  setQuery: (val: string) => void;
}

const Search: React.FC<IProps> = ({ placeholder, query, setQuery }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setQuery(event?.target?.value ?? '');

  return (
    // <div className="relative inline-block mt-7 mb-1">
    <div className="relative inline-block xl:mb-1 w-52 xl:w-72">
      <input
        type="text"
        placeholder={placeholder}
        value={query}
        onChange={handleChange}
        className="bg-pure-white text-black ring- shadow placeholder:text-sm rounded-full appearance-none ring-1 py-[10px] pl-4 
        pr-8 w-52 xl:w-72 ring-border-color-dark focus:outline-none focus:shadow-outline placeholder:text-light-grey placeholder:capitalize "
      />
      <RiSearchLine
        className="absolute top-3.5 right-4"
        size={18}
        color="#4062FF"
      />
    </div>
  );
};

export default React.memo(Search);
